// EXTERNAL DEPENDENCIES
import React, { useMemo, useEffect } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Box, Container } from "@material-ui/core";
import { routes } from "navigation/config";
import { useTranslation } from "react-i18next";

// INTERNAL DEPENDENCIES
import Page from "components/Page";
import Navigation from "components/Navigation";
import Footer from "components/Footer";
import { useStyles } from "styling/mainStyles";
import { useLocale } from "hooks";

const App = () => {
  const classes = useStyles();
  const { localeState } = useLocale();
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(localeState.locale);
  }, [localeState.locale, i18n]);

  const renderRoutes = useMemo(() => {
    const renderedRoutes = [];
    for (const route in routes) {
      renderedRoutes.push(
        <Page
          key={routes[route].title}
          exact={routes[route].exact}
          path={routes[route].path}
          component={routes[route].component}
          route={route}
        />
      );
    }
    return renderedRoutes;
  }, []);

  return (
    <Router>
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        className={classes.body}
      >
        <Navigation />
        <Container className={classes.mainContainer} maxWidth="md">
          <Switch>{renderRoutes}</Switch>
        </Container>
        <Footer />
      </Box>
    </Router>
  );
};

export default App;
